import { useMemo, useState } from "react";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { useFilterProvider } from "../FilterProvider";
import type { SearchFilterConfiguration } from "../types";

interface SearchFilterInputProps {
  configuration: SearchFilterConfiguration;
}

export const SearchFilterInput = ({
  configuration,
}: SearchFilterInputProps) => {
  const { filterParamForKey, setFilter, clearFilterByKey } =
    useFilterProvider();

  const param = useMemo((): BaseFilter => {
    const existingFilter = filterParamForKey(configuration.key) as
      | BaseFilter
      | undefined;

    return {
      id: configuration.key,
      key: configuration.key,
      value: existingFilter?.value ?? "",
    };
  }, [filterParamForKey, configuration.key]);

  const [searchValue, setSearchValue] = useState(param.value as string);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value === "") {
      clearFilterByKey(configuration.key);
    } else {
      setFilter(configuration.key, {
        ...param,
        search_key: configuration.search_key,
        value,
      });
    }
  };

  return (
    <div className="flex-1">
      <input
        type="text"
        placeholder={configuration.label}
        value={searchValue}
        onChange={handleChange}
        className="border-primary focus:border-secondary w-full rounded-lg border px-3 py-2 text-sm"
      />
    </div>
  );
};
